import styles from "./AsideRightControllerIcon.module.scss";

function AsideRightControllerIcon({ display, onChange, icons }) {

  const menu = icons.map((icon, index) => (
    <div
      className={`${styles["icon"]} ${display === index ? styles["icon--selected"] : ""}`}
      key={index}
      onClick={() => onChange(index)}>
      {icon}
    </div>
  ));

  return <div className={`${styles["aside-controller"]}`}>{menu}</div>;
}

export default AsideRightControllerIcon;
